import { boolean, object, array, string, mixed, number } from 'yup';

const makeSchema = step => {
  if (!step) return;
  let schema = {};

  if (step === 1) {
    schema = {
      rating: number()
        .min(1, 'You have to rate the answer')
        .max(5)
        .required('Rate is required'),
      comment: string().notRequired(),
      // required('Comment is required!'),
    };
  } else {
    schema = {
      rating: number()
        .min(1, 'You have to rate the answer')
        .max(5)
        .required('Rate is required'),
      quantityValue: number()
        .typeError('Quantities must be a number')
        .required('Quantities are required'),
      comment: string().required('Comment is required'),
      quantityUnit: string().required('Unit is required'),
      projectInfoVisible: boolean().notRequired(),
    };
  }

  return object().shape(schema);
};

export default makeSchema;
